<template>
  <div class="banner-container" ref="bannerContainer" v-if="data.length">
    <div class="banner-list">
      <div
        class="banner-item"
        v-for="(item, index) in data"
        :key="index"
        :style="{}"
        @click="bindClick(item)"
      >
        <img class="image" :src="item.img" alt="" />
        <div class="text">{{ item.title }}</div>
        <div class="iconfont icon-you"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  methods: {
    bindClick(item) {
      if (this.$http._isApp()) {
        item.router && this.$betterwe.onAppPageRoute(item.router)
      } else {
        location.href =
          'https://member3.gymcity.com.cn/#/app-download?token=' +
          localStorage.getItem('token')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.banner-container {
  width: 100%;
  height: 40px;
  .banner-list {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    overflow-x: scroll;
    .banner-item {
      flex-shrink: 0;
      width: 100%;
      height: 40px;
      border-radius: 12px;
      background: #f9f9f9;
      display: flex;
      align-items: center;
      padding: 0px 12px 0px 17px;
      box-sizing: border-box;
      margin-left: 20px;
      .image {
        width: 24px;
        height: 24px;
        background: #ff6565;
        border-radius: 6px;
        object-fit: cover;
      }
      .text {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.8);
        line-height: 18px;
        margin: 0px 10px;
      }
      .iconfont {
        width: 16px;
        height: 16px;
        background: #ffffff;
        border: 1px solid #f1f1f1;
        border-radius: 50%;
        display: flex;
        align-items: center;
        color: #999;
      }
    }
    .banner-item:first-child {
      margin-left: 0px;
    }
  }
}
</style>
